import { Row, Col } from "react-bootstrap";
import InputSearch from "../../../../../components/inputs/InputSelectSearch";
import InputDnD from "../../../../../components/inputs/InputDnD";
import { Image } from "react-bootstrap";
import { enumToArray } from "../../../../../libs/formats";
import { TypeDocument } from "../../../../../enums/TypeDocument.enum";

const tipos = enumToArray(TypeDocument, "allValues");
const FileScreen = ({
  values,
  errors,
  touched,
  onChange,
  handleBlur,
  // tipos,
  sistemas,
  tiposCarpeta,
}: {
  values: any;
  errors: any;
  touched: any;
  onChange: any;
  handleBlur: any;
  // tipos: any;
  sistemas: any;
  tiposCarpeta: any;
}) => {
function showInput() { return ![ TypeDocument.TESIS, TypeDocument.ACUERDOS, 
   TypeDocument.LIBRE, ].includes(values.tag); }

  return (
    <div>
      <Row>
        <Col xs={12}>
          <InputDnD
            name="file"
            label="Archivo"
            value={values.file}
            accepts="application/pdf"
            onChangeMethod={onChange}
            errors={errors.file}
            touched={touched.file}
            listType="picture-text"
            renderThumbnail={() => (
              <div className="bg-white border-end w-100 h-100">
                <Image
                  src="images/files/pdf-img.svg"
                  className="mt-1"
                  width="40"
                  height="40"
                />
              </div>
            )}
            required
          />
        </Col>
      </Row>
      <Row className="d-flex justify-content-around">
        <Col xs={12} md={5}>
          <InputSearch
            label="Tipo de archivo"
            name="tag"
            value={values.tag}
            error={errors.tag}
            touched={touched.tag}
            values={tipos}
            // labelVal="name"
            // valueVal="_id"
            onChangeMethod={onChange}
            // disabled={tipos.length < 1}
            required
          />
        </Col>
        {showInput() && (
          <Col xs={12} md={5}>
            <InputSearch
              label="Sistema"
              name="sistema"
              value={values.sistema}
              touched={touched.sistema}
              error={errors.sistema}
              values={sistemas}
              labelVal="name"
              valueVal="_id"
              onChangeMethod={onChange}
              onBlurMethod={handleBlur}
              required={showInput()}
            />
          </Col>
        )}
      </Row>
      {showInput() && (
        <Row className="d-flex justify-content-around">
          <Col xs={12} md={5}>
            <InputSearch
              label="Tipo de Carpeta"
              name="folderType"
              value={values.folderType}
              touched={touched.folderType}
              error={errors.folderType}
              values={tiposCarpeta}
              labelVal="name"
              valueVal="_id"
              onChangeMethod={onChange}
              onBlurMethod={handleBlur}
              required={showInput()}
            />
          </Col>
        </Row>
      )}
    </div>
  );
};

export default FileScreen;
